/**
 * Where people write to Order Bot: the privacy policy, the terms and the landing page's footer.
 * Its own module so the landing page can show it without pulling in the legal texts.
 */
export const CONTACT_EMAIL = 'sandeepks9199@gmail.com';
